import util from "./_util";

const { request } = util;

export default {
  // 委托添加
  entrustAdd(data) {
    return request.post("/Entrust/save_entrust", data);
  },

  // 委托删除
  entrustDel(params) {
    return request.get("/Entrust/delete_entrust?ids=" + params);
  },

  // 委托作废
  entrustToVoid(params) {
    return request.get("/Entrust/delete_entrust?ids=" + params);
  },

  // 委托修改
  entrustUpdate(data) {
    return request.post("/Entrust/update_entrust_list", data);
  },

  // 委托复核
  entrustToReview(data) {
    return request.get("/Entrust/review_entrust_yes", data);
  },

  // 复核通过(批量复核)
  PassToReview(params) {
    return request.get("/Entrust/review_entrust_yes?entrus_id=" + params);
  },
  // 复核通过(批量复核)
  noPassToReview(params) {
    return request.get("/Entrust/review_entrust_no?entrus_id=" + params);
  },
  // 检测项目联动获取默认检测标准和相关的检测参数
  jcbzjcxxGetAll(params) {
    return request.get("/TestItem/GetProjectTypeInfo?id=" + params);
  },

  // 根据ID查询详情
  entrustFindByID(params) {
    return request.get("/wtxx/get_by_id?id=" + params);
  },
};
